export const reglamentoInterior = [
    {
        'nombreDocumento' : 'Reglamento Interior de la Secretaría de Infraestructura Pública y Desarrollo Urbano Sostenible',
        'urlDocumento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/ReglamentoSIPDUS.pdf',
        'icono' : 'icon-normativity'
    },
    {
        'nombreDocumento' : 'Decreto que adiciona, reforma y deroga diversas disposiciones del Reglamento Interior de la Secretaría de Infraestructura Pública y Desarrollo Urbano Sostenible',
        'urlDocumento' : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/DecretoReglamentoSIPDUS.pdf',
        'icono' : 'icon-code'
    },
]